import { typeMetaEnum, EnumMetaType } from "@/autogen/common";
import { PhoneType } from "./PhoneType";

export type PhoneTypeMetaI = EnumMetaType<typeof PhoneType, PhoneType>;
export const PhoneTypeMeta = typeMetaEnum<typeof PhoneType, PhoneType>("PhoneType", PhoneType);

